import Burger from './Burger';

export default Burger;



// WEBPACK FOOTER //
// ./src/components/Burger/index.js